<template>
  <div class="content">
    <div class="top">
      <img
        src="../../assets/images/news.png"
        alt=""
      >
      暂无最新消息
    </div>
    <div class="body">
      <div class="top">
        <span>产品审批</span>
      </div>
      <el-tabs
        v-model="activeName"
        @tab-click="handleClick"
      >
        <el-tab-pane
          label="待审核"
          name="first"
        >
          <el-table
            :data="tableData"
            style="width: 100%"
          >
            <el-table-column
              prop="bankName"
              label="银行"
            >
            </el-table-column>
            <el-table-column
              prop="name"
              label="产品名称"
            >
            </el-table-column>
            <el-table-column
              prop="createTime"
              label="申请日期"
            >
            </el-table-column>
            <el-table-column
              prop="proName"
              label="申请类型"
            >
              <!-- <template slot-scope="scope">
                <span v-if="scope.row.type==1">新产品发布</span>
                <span v-if="scope.row.type==0">已有产品修改</span>
              </template> -->
            </el-table-column>
            <el-table-column
              prop="parentName"
              label="审核状态"
            >
            </el-table-column>
            <el-table-column
              prop="operation"
              label="操作"
            > <template slot-scope="scope">
                <span
                  @click="operation(scope.row)"
                  style="color: #2981EE;"
                >审批</span>
              </template>
            </el-table-column>
          </el-table>
          <el-dialog
            title="查看详情"
            :visible.sync="dialogVisible"
            width="25%"
            center
            :show-close="false"
            :modal-append-to-body="false"
            :lock-scroll="false"
          >
            <div class="details">
              <div>产品简介：<span>{{detailList.name}}</span></div>
              <div>
                贷款额度：<span>{{detailList.loanLimitFloor}}-{{detailList.loanLimitCap}}
                  万元</span>
              </div>
              <div>
                利率范围：<span>{{detailList.interestRateFloor}}-{{detailList.interestRateCap}}
                  %</span>
              </div>
              <div>
                贷款期限：<span>{{detailList.minLoanTime}}-{{detailList.maxLoanTime}}
                  月</span>
              </div>
              <div>贷款类型：<span>{{detailList.typeName}}</span></div>
              <div>
                申请条件：<span>{{detailList.conditions}}</span>
              </div>
              <div>
                所需材料：<span>{{detailList.materials}}</span>
              </div>

            </div>
            <div class="button">
              <el-button @click="dialogVisible = false">返 回</el-button>
              <el-button
                type="primary"
                @click="operationDetails"
              >审 批</el-button>
            </div>
          </el-dialog>
          <el-dialog
            title="审批结果"
            :visible.sync="DetailsVisible"
            width="25%"
            :show-close="false"
            :modal-append-to-body="false"
            :lock-scroll="false"
          >
            <div>
              结果：
              <el-radio-group
                v-model="radio"
                @change="handerRadio"
              >
                <el-radio :label="false">通过</el-radio>
                <el-radio :label="true">不通过</el-radio>
              </el-radio-group>
            </div>
            <div
              class="textarea"
              v-if="radio"
            >
              <span>原因:</span>
              <el-form
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
              >
                <el-form-item prop="textarea">
                  <el-input
                    type="textarea"
                    :rows="1"
                    :max="2"
                    v-model="ruleForm.textarea"
                  >
                  </el-input>
                </el-form-item>
              </el-form>
            </div>
            <div class="button">
              <el-button @click="DetailsVisible = false">取 消</el-button>
              <el-button
                type="primary"
                @click="detailtEnter('ruleForm')"
              >确 认</el-button>
            </div>
          </el-dialog>
        </el-tab-pane>
        <el-tab-pane
          label="审核历史"
          name="second"
        >
          <el-table
            :data="historyData"
            style="width: 100%"
            v-loading="loading"
          >
            <el-table-column
              prop="bankName"
              label="银行"
            >
            </el-table-column>
            <el-table-column
              prop="name"
              label="产品名称"
            >
            </el-table-column>
            <el-table-column
              prop="createTime"
              label="申请日期"
            >
            </el-table-column>
            <el-table-column
              prop="typeName"
              label="申请类型"
            >
            </el-table-column>
            <el-table-column
              prop="statusName"
              label="审核状态"
            >
            </el-table-column>
            <el-table-column
              prop="operation"
              label="操作"
            >
              <template slot-scope="scope">
                <span
                  style="color: #2981EE;"
                  @click="detailsShow(scope.row)"
                >详情</span>
              </template>

            </el-table-column>
          </el-table>
          <!-- ----------------------------- -->
          <el-dialog
            title="查看详情"
            :visible.sync="dialogdetails"
            width="25%"
            center
            :show-close="false"
            :modal-append-to-body="false"
            :lock-scroll="false"
          >
            <div class="details">
              <div>产品简介：<span>{{Detail.name}}</span></div>
              <div>
                贷款额度：<span>{{Detail.loanLimitFloor}}-{{Detail.loanLimitCap}}
                  万元</span>
              </div>
              <div>
                利率范围：<span>{{Detail.interestRateFloor}}-{{Detail.interestRateCap}}
                  %</span>
              </div>
              <div>
                贷款期限：<span>{{Detail.minLoanTime}}-{{Detail.maxLoanTime}}
                  月</span>
              </div>
              <div>贷款类型：<span>{{Detail.typeName}}</span></div>
              <div>
                申请条件：<span>{{Detail.conditions}}</span>
              </div>
              <div>
                所需材料：<span>{{Detail.materials}}</span>
              </div>
              <div v-if="Detail.reson == '审核通过'">
                审核结果：<span>审批通过</span>
              </div>
              <div v-if="Detail.reson !== '审核通过'">
                审核结果：<span>审批不通过</span>
              </div>
              <div v-if="Detail.reson !== '审核通过'">
                原因：<span>{{Detail.reson}}</span>
              </div>
            </div>
            <div class="button">
              <el-button @click="dialogdetails = false">确 认</el-button>
            </div>
          </el-dialog>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import { list, examine, selectHistoryList, detail, detailByExamineId } from '@/api/statistics'
import Utils from '@/utils/utils'
export default {
  data () {
    return {
      activeName: 'first',
      tableData: [],
      dialogVisible: false,
      DetailsVisible: false,
      radio: false,
      ruleForm: {
        textarea: '',
      },
      detailList: {},
      result: "通过",
      historyData: [],
      dialogdetails: false,
      Detail: {},
      rules: {
        textarea: [
          { required: true, message: '请输入不通过原因', trigger: 'blur' }]
      },
      loading: true
    }
  },
  created () {
    this.getList()
  },
  methods: {
    detailsShow (e) {
      let params = {
        id: e.id
      }
      detailByExamineId(this.sendParam(params)).then(res => {
        res = this.paramDecrypt(res);
        if (res.code == 200) {
          this.Detail = res.data
        } else {
          this.$message.error(res.msg);
        }
      })
      this.dialogdetails = true
    },
    operation (e) {
      this.detailList = e
      this.dialogVisible = true
    },
    operationDetails () {
      this.dialogVisible = false
      this.DetailsVisible = true
    },
    handerRadio (e) {
      if (e == false) {
        this.result = '通过'
      } else if (e == true) {
        this.result = '不通过'
      }
      this.radio = e
    },
    //获取审批列表
    getList () {
      let params = { status: 1 }
      list(this.sendParam(params)).then(res => {
        res = this.paramDecrypt(res);
        if (res.code == 200) {
          res.data.forEach((item) => {
            item.createTime = Utils.timestampToTimeLong(item.createTime)
          })
          this.tableData = res.data;
        }
      }).catch(err => {

      })

    },
    handleClick (e) {
      if (e.index == 0) {
        this.getList()
      } else if (e.index == 1) {
        this.getHistoryList()
      }
    },
    getHistoryList () {
      let params = {}
      selectHistoryList(this.sendParam(params)).then(res => {
        res = this.paramDecrypt(res);
        if (res.code == 200) {
          res.data.forEach((item) => {
            item.createTime = Utils.timestampToTimeLong(item.createTime)
          })
          this.historyData = res.data
          this.loading = false
        }
      }).catch(err => {

      })
    },
    detailtEnter (formName) {
      if (this.result == '不通过') {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let params = {
              result: this.result,
              reason: this.ruleForm.textarea,
              productInfo: {
                id: this.detailList.id,
                status: this.detailList.status,
              }
            }
            examine(this.sendParam(params)).then(res => {
              res = this.paramDecrypt(res);
              if (res.code == 200) {
                this.$message.success("审核成功")
                this.DetailsVisible = false
                this.getList()
              } else {
                this.$message.error("审核失败")
              }
            }).catch(err => { })
          } else {
            return false;
          }
        });
      } else if (this.result == '通过') {
        let params = {
          result: this.result,
          reason: this.ruleForm.textarea,
          productInfo: {
            id: this.detailList.id,
            status: this.detailList.status,
          }
        }
        examine(this.sendParam(params)).then(res => {
          res = this.paramDecrypt(res);
          if (res.code == 200) {
            this.$message.success("审核成功")
            this.DetailsVisible = false
            this.getList()
          } else {
            this.$message.error("审核失败")
          }
        }).catch(err => { })
      }


    }

  }
}
</script>
<style lang='less' scoped>
.content {
  width: 100%;
  min-height: 986px;
  .top {
    width: 100%;
    height: 40px;
    background: #ffffff;
    border: 1px solid #ededed;
    box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    display: flex;
    align-items: center;
    font-size: 14px;
    font-family: Alibaba PuHuiTi;
    font-weight: 400;
    color: #2a2a2a;
    img {
      width: 12px;
      height: 12px;
      margin: 0 10px 0 20px;
    }
  }
  .body {
    margin-top: 24px;
    background-color: #fff;
    width: 100%;
    min-height: 920px;
    border-radius: 8px;
    .top {
      height: 60px;
      width: 100%;
      span {
        font-size: 24px;
        font-family: Alibaba PuHuiTi;
        font-weight: 500;
        color: #2981ee;
        height: 28px;
        border-left: 8px solid #2981ee;
        line-height: 28px;
        padding-left: 27px;
      }
    }
    /deep/ .el-tabs__nav-wrap::after {
      position: static !important;
    }
    /deep/ .el-tabs__header {
      width: 100%;
      height: 42px;
      background: #f3f4f9;
      padding-left: 44px;
      box-sizing: border-box;
      margin: 0;
      .el-tabs__item.is-active {
        font-size: 18px;
        font-family: Alibaba PuHuiTi;
        font-weight: 500;
        color: #2a2a2a;
      }
      .el-tabs__item is-top {
        font-size: 18px;
        font-family: Alibaba PuHuiTi;
        font-weight: 500;
        color: #818181;
      }
      .el-tabs__item:hover {
        color: #2a2a2a;
        cursor: pointer;
      }
    }
    /deep/ .el-table th {
      border-top: 1px solid #fff;
      background: #f3f4f9;
    }
    /deep/ .el-dialog__body {
      border-top: 1px solid #f3f4f9;
    }
    .details {
      width: 100%;
      min-height: 300px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      font-size: 16px;
      font-family: Alibaba PuHuiTi;
      font-weight: 600;
      color: #000000;
      div {
        margin-top: 15px;
        span {
          font-size: 16px;
          font-family: Alibaba PuHuiTi;
          font-weight: 400;
          color: #2a2a2a;
        }
      }
    }
    .button {
      margin-top: 40px;
      width: 100%;
      display: flex;
      justify-content: center;
    }
    .textarea {
      margin-top: 23px;
      span {
        white-space: nowrap;
        margin-right: 15px;
        margin-top: 10px;
      }
      display: flex;
      // justify-content: space-between;
    }
  }
}
</style> 